import React from "react";
import { Col, Row, Card } from "antd";
import workbench from "../images/workbench.svg";
import { TryProduct } from "./TryTheProduct";

interface userProp { currentUser: any; }

const Workbench: React.FC<userProp> = ({ currentUser }) =>  {
  return (
    <Card hoverable bodyStyle={{width: '100%'}} className={currentUser ? "product-layout product-layout-logged" : "product-layout"}>
      <div >
      <Row>
        <Col>
        <div className="product-description-img workbench">
          <div className="product-img-border">
            <img
              className="product-img"
              src={workbench}
              height="100%"
              alt="workbench-logo"
            />
          </div>
        </div>
        </Col>
        </Row>
        <p className="eyebrow-text">Explore your ideas</p>
        <h2 className="h2 h2-workbench">Modeling Workbench</h2>
        <p className="p" style={{width: '100%'}}>
        As Science Central evolves, you can build, train, and deploy machine learning and simulation models.
        </p>
        <p className="product-button">Build Models
          <TryProduct />
        </p>
      </div>
</Card>
  );
};

export default Workbench;
